import script from "./ImageUploadWall.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImageUploadWall.vue?vue&type=script&setup=true&lang=ts"

import "./ImageUploadWall.vue?vue&type=style&index=0&id=adea23f4&scoped=true&lang=less"
import "./ImageUploadWall.vue?vue&type=style&index=1&id=adea23f4&lang=less"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.18_vue@3.5.18_typescript@5.8.3__webpack@5.101.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-adea23f4"]])

export default __exports__